import { render, staticRenderFns } from "./addPaymentMethod.vue?vue&type=template&id=ef44c9ce"
import script from "./addPaymentMethod.vue?vue&type=script&lang=js"
export * from "./addPaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports